import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, styled } from '@mui/material';
import { sxTable } from '../sxProps';
import { PedidoReembolsoDetalhe } from '../../../../../interfaces/entities/Reembolso/PedidoReembolsoDetalhe';
import { useAccessibility } from '../../../../../Store/contexts/AccessibilityContext';

const AprovadoCard = (props: { reembolso?: PedidoReembolsoDetalhe, onAnexoClicked: (idAnexo: string) => void }) => {
  const { reembolso, onAnexoClicked } = props;

  const accessibility = useAccessibility();

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    fontFamily: 'Unimed-Sans',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    width: '25%',
    ...accessibility.textStyleAccessibility
  }));

  const StyledTableTitle = styled(TableCell)(({ theme }) => ({
    fontStyle: 'normal',
    fontWeight: 700,
    fontFamily: 'UnimedSans-Bold',
    lineHeight: '150%',
    ...accessibility.textStyleAccessibility,
    fontSize: accessibility.alterFontSizeMode ? accessibility.fontSize : '16px',
    color: accessibility.contrastMode ? 'white' : 'var(--Grey-Dark-Dark, #4C4C4C)',
}));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: '#F9F9F9'
    },
  }));


  return (
    <div>
      <div className='margin-bottom-20'>
        <h2 className='title-detalhe-card' style={accessibility.textStyleAccessibility}>Aprovado</h2>
      </div>
      <div className="registration-data-card-holder margin-bottom-20">
        <div className="registration-data-card-service" style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility }}>
          <div className="registration-data-row">
            <span className="registration-data-title" style={accessibility.textStyleAccessibility}>Dados do beneficiário(a)</span>
          </div>
          <div className="registration-data-row registration-data-row-secondary" style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility }}>
            <span className="registration-data-key" style={accessibility.textStyleAccessibility}>Nome</span>
            <span className="registration-data-value" style={accessibility.textStyleAccessibility}>{reembolso?.nomeBeneficiario}</span>
          </div>
          <div className="registration-data-row">
            <span className="registration-data-key" style={accessibility.textStyleAccessibility}>Telefone</span>
            <span className="registration-data-value" style={accessibility.textStyleAccessibility}>{reembolso?.telCelular}</span>
          </div>
          <div className="registration-data-row registration-data-row-secondary" style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility }}>
            <span className="registration-data-key" style={accessibility.textStyleAccessibility}>E-mail</span>
            <span className="registration-data-value" style={accessibility.textStyleAccessibility}>{reembolso?.email}</span>
          </div>
          <div className="registration-data-row">
            <span className="registration-data-key" style={accessibility.textStyleAccessibility}>Protocolo</span>
            <span className="registration-data-value" style={accessibility.textStyleAccessibility}>{reembolso?.codProtocAns}</span>
          </div>
          <div className="registration-data-row registration-data-row-secondary" style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility }}>
            <span className="registration-data-key" style={accessibility.textStyleAccessibility}>Data da solicitação</span>
            <span className="registration-data-value" style={accessibility.textStyleAccessibility}>{reembolso?.dtPedido}</span>
          </div>
        </div>
      </div>
      <div className="registration-data-card-holder margin-bottom-20">
        <div className="registration-data-card-service" style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility }}>
          <div className="registration-data-row">
            <span className="registration-data-title" style={accessibility.textStyleAccessibility}>Dados bancários</span>
          </div>
          <div className="registration-data-row registration-data-row-secondary" style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility }}>
            <span className="registration-data-key" style={accessibility.textStyleAccessibility}>Conta</span>
            <span className="registration-data-value" style={accessibility.textStyleAccessibility}>{reembolso?.conta}</span>
          </div>
          <div className="registration-data-row">
            <span className="registration-data-key" style={accessibility.textStyleAccessibility}>Titular da conta</span>
            <span className="registration-data-value" style={accessibility.textStyleAccessibility}>{reembolso?.titularConta}</span>
          </div>
          <div className="registration-data-row registration-data-row-secondary" style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility }}>
            <span className="registration-data-key" style={accessibility.textStyleAccessibility}>CPF do titular</span>
            <span className="registration-data-value" style={accessibility.textStyleAccessibility}>{reembolso?.cpfTitularConta}</span>
          </div>
          <div className="registration-data-row">
            <span className="registration-data-key" style={accessibility.textStyleAccessibility}>Banco</span>
            <span className="registration-data-value" style={accessibility.textStyleAccessibility}>{reembolso?.banco}</span>
          </div>
          <div className="registration-data-row registration-data-row-secondary" style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility }}>
            <span className="registration-data-key" style={accessibility.textStyleAccessibility}>Agência</span>
            <span className="registration-data-value" style={accessibility.textStyleAccessibility}>{reembolso?.agencia}</span>
          </div>
          <div className="registration-data-row">
            <span className="registration-data-key" style={accessibility.textStyleAccessibility}>Número da conta</span>
            <span className="registration-data-value" style={accessibility.textStyleAccessibility}>{reembolso?.numConta}</span>
          </div>
          <div className="registration-data-row registration-data-row-secondary" style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility }}>
            <span className="registration-data-key" style={accessibility.textStyleAccessibility}>Tipo da conta</span>
            <span className="registration-data-value" style={accessibility.textStyleAccessibility}>{reembolso?.tipoConta}</span>
          </div>
        </div>
      </div>
      <div className="registration-data-card-holder margin-bottom-20">
        <div className="registration-data-card-service" style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility }}>
          <div className="registration-data-row">
            <span className="registration-data-title" style={accessibility.textStyleAccessibility}>Dados do pagamento</span>
          </div>
          <div className="registration-data-row registration-data-row-secondary" style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility }}>
            <span className="registration-data-key" style={accessibility.textStyleAccessibility}>Valor total do gasto</span>
            <span className="registration-data-value" style={accessibility.textStyleAccessibility}>{reembolso?.valorTotalGasto}</span>
          </div>
          <div className="registration-data-row">
            <span className="registration-data-key" style={accessibility.textStyleAccessibility}>Anexo(s)</span>
            <span className="registration-data-value" style={accessibility.textStyleAccessibility}>{reembolso?.listaArquivos.map((a, i) => (<>
              <label id={`anexo-label-${i}`} aria-label={`Baixar anexo ${a.nomeArquivo} do pedido de reembolso`} />
              <div className='clickable' tabIndex={0} style={accessibility.textStyleAccessibility} onClick={() => onAnexoClicked(a.idArqReembolso)} aria-labelledby={`anexo-label-${i}`}><span aria-hidden="true">{a.nomeArquivo}</span></div>
            </>))}</span>
          </div>
        </div>
      </div>

      <div className="registration-data-card-holder margin-bottom-20">
        <TableContainer className="registration-data-title" sx={sxTable} style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility}} component={Paper}>
          <Table stickyHeader size="medium" aria-label="a dense table">
            <TableHead>
              <TableRow><StyledTableTitle colSpan={3}>Histórico da Solicitação</StyledTableTitle></TableRow>
              <TableRow>
                <StyledTableCell align="left"><b>Data</b></StyledTableCell>
                <StyledTableCell align="left"><b>Status</b></StyledTableCell>
                <StyledTableCell align="left"><b>Observação</b></StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {reembolso?.listaOcorrencia.map((row) => (
                <StyledTableRow
                  key={row.dt_hora_abertu}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <StyledTableCell component="th" scope="row">
                    {row.dt_hora_abertu}
                  </StyledTableCell>
                  <StyledTableCell align="left">{row.status}</StyledTableCell>
                  <StyledTableCell align="left">{row.obs}</StyledTableCell>

                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  )
}

export default AprovadoCard